<template>
  <div class="vehicle-form">
    <label>
      Марка
      <input
        :value="make"
        type="text"
        class="input"
        maxlength="100"
        required
        :disabled="disabled"
        @input="$emit('update:make', $event.target.value)"
      />
    </label>

    <label>
      Комплектация
      <textarea
        :value="equipment"
        class="input"
        rows="3"
        maxlength="5000"
        placeholder="Колёса, лебёдка, подвеска и другие модификации"
        :disabled="disabled"
        @input="$emit('update:equipment', $event.target.value)"
      />
    </label>

    <label>
      Фотографии
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        :disabled="disabled"
        @change="onPhotosSelected"
      />
    </label>
    <p v-if="photos.length" class="field-hint">{{ photos.length }} фото выбрано</p>
  </div>
</template>

<script setup>
defineProps({
  make: {
    type: String,
    default: '',
  },
  equipment: {
    type: String,
    default: '',
  },
  photos: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:make', 'update:equipment', 'update:photos'])

function onPhotosSelected(event) {
  emit('update:photos', Array.from(event.target.files || []))
}
</script>

<style scoped>
.vehicle-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.vehicle-form label {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-weight: 600;
}

.field-hint {
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
}
</style>
